import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesFinanceiro {
  ler: boolean;
  criar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `financeiro`
 * (`apps/api/src/modules/financeiro/financeiro.routes.ts`, seed original
 * da migration `004`): `admin` (curinga `*`) e o papel `financeiro` têm
 * `ler`/`criar`/`atualizar`/`excluir` — esta tela só usa `ler`/`criar`.
 * Nenhum outro papel (`producao`/`marketing`/`suporte`/`parceiros`) tem
 * qualquer permissão sobre este recurso (`PRODUCT.md` 4.3/4.6/4.7 —
 * "Não acessa: Financeiro"). Usado apenas para decidir o que mostrar na
 * UI — a autorização real é sempre revalidada pelo backend.
 */
export function permissoesFinanceiro(papel: PapelUsuario): PermissoesFinanceiro {
  if (papel === 'admin' || papel === 'financeiro') {
    return { ler: true, criar: true };
  }
  return { ler: false, criar: false };
}
